import styled from 'styled-components';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var PLACEMENTS = Object.freeze({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
});

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Container = styled.label.withConfig({
  componentId: "gz-checkbox-1673535246793__sc-r03taa-0"
})(["align-items:center;display:inline-flex;line-height:1;position:relative;vertical-align:middle;", ""], function (_ref) {
  var placement = _ref.placement;

  if (placement === PLACEMENTS.RIGHT) {
    return "\n        flex-direction: row;\n      ";
  }

  if (placement === PLACEMENTS.LEFT) {
    return "\n        flex-direction: row-reverse;\n      ";
  }

  if (placement === PLACEMENTS.TOP) {
    return "\n        flex-direction: column-reverse;\n      ";
  }

  if (placement === PLACEMENTS.BOTTOM) {
    return "\n        flex-direction: column;\n      ";
  }

  return '';
});

export { Container as C, PLACEMENTS as P };
